import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

import BreadcrumbCard from '../utils/BreadcrumbCard'
import '../App.css'

class NotFound extends Component {
    static Title = "Not Found"

    render() {
        const breadcrumbs = [
            {
                title: "Not Found",
                active: true,
            }
        ]

        const path = window.location.pathname

        return (
            <BreadcrumbCard breadcrumbs={ breadcrumbs } id={ "not-found" }>
                <div style={{ textAlign: 'center', padding: '2em 1em' }}>
                    <div className="not-found-terminal">
                        <div className="not-found-terminal-bar">
                            <span className="not-found-dot" style={{ background: '#ff5f57' }} />
                            <span className="not-found-dot" style={{ background: '#ffbd2e' }} />
                            <span className="not-found-dot" style={{ background: '#28c840' }} />
                        </div>
                        <div className="not-found-terminal-body">
                            <p><span className="not-found-prompt">$ </span>GET {path} HTTP/1.1</p>
                            <p><span className="not-found-header-key">Host</span>: appler.pw</p>
                            <p>&nbsp;</p>
                            <p>HTTP/1.1 <span className="not-found-status">404 Not Found</span></p>
                            <p><span className="not-found-header-key">Content-Type</span>: text/html; charset=utf-8</p>
                            <p>&nbsp;</p>
                            <p>Error: the page you requested could not be found.</p>
                            <p>&nbsp;</p>
                            <p><span className="not-found-prompt">$ </span><span className="not-found-cursor">▮</span></p>
                        </div>
                    </div>
                    <Button variant="outline" render={<Link to="/" />} style={{ marginTop: '1.5em' }}>
                        ← Go home
                    </Button>
                </div>
            </BreadcrumbCard>
        )
    }
}

export default NotFound
